module.exports = __webpack_public_path__ + "static/media/drag_card.68ae77b1.gif";